/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Button, Heading, Icon, StyledModal, Inline } from 'sarsaparilla';
import CellCoverageLine from './CellCoverageLine';
// import type { cellAggregateRating } from '../model/aggregate';
import { describeCoverage, describeCoverageLong } from '../utils/cellCoverage';

// type PropTypes = {
//   cellRatings: Array<cellAggregateRating>,
// };

// type State = {
//   showModal: boolean,
// };

export default class CellCoverage extends React.PureComponent {
    static defaultProps = {
        cellRatings: [],
    };

    state = {
        showModal: false,
    };

    toggleShowModal() {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal });
    }

    render() {
        const { cellRatings } = this.props;
        const { showModal } = this.state;
        const items = [];
        for (let i = 4; i >= 0; i--) {
            items.push(
                <li key={`cell-coverage-modal-li-${i}`}>
                    <strong>
                        {i}. {describeCoverage(i)}
                    </strong>
                    <p>{describeCoverageLong(i)}</p>
                </li>
            );
        }
        return (
            <div className="cell-coverage-wrapper">
                <Inline space="xxs" alignY="start">
                    <Heading headingLevel={2} appearance="h6">
                        Mobile Coverage
                    </Heading>

                    <Button
                        appearance="subtle"
                        size="xs"
                        onClick={this.toggleShowModal.bind(this)}
                        iconBeforeElement={<Icon iconName="info" />}
                        screenReaderTextBefore="Show coverage rating descriptions"
                        className="cell-coverage-modal-button"
                    />
                    <StyledModal
                        id="cell-coverage-explainer-modal"
                        role="complementary"
                        onRequestClose={this.toggleShowModal.bind(this)}
                        isOpen={showModal}
                        shouldShowCloseButton
                        heading={'Cell Coverage Strength'}
                    >
                        <div className="rec-modal-content-wrap">
                            <ul>{items}</ul>
                        </div>
                    </StyledModal>
                </Inline>

                <div className="cell-table-wrap">
                    {cellRatings.map((rating) => (
                        <CellCoverageLine
                            cellRating={rating}
                            key={`coverage-${rating.carrier}`}
                        />
                    ))}
                </div>
            </div>
        );
    }
}
